module.exports = __webpack_public_path__ + "fonts/f803d8e8ab86c9c0eb9ad1da9978f9f5.svg";